/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { put, select, takeLatest } from 'redux-saga/effects'
import { getCrewSelector } from '../selectors'
import { setCrewList } from '../store/crew.actions'
import { CrewConstants } from '../store/crew.constants'
import { ICrewState } from '../store/crew.types'

export function* setCertification() {
  const crew: ICrewState = yield select(getCrewSelector)
  const { crewMember, crewList, certificationLevelId } = crew

  const selectedCrew = crewList.filter((cl) => cl.key === crewMember?.key)
  if (selectedCrew && selectedCrew.length) {
    selectedCrew[0].certificationLevelId = certificationLevelId
  }
  yield put(setCrewList(crewList))
}

export function* setCertificationLevelSaga() {
  yield takeLatest([CrewConstants.SET_CERTIFICATION_LEVEL], setCertification)
}
